import { bianka, BIANKA_ACTIVITY_TYPES, mixpanel } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { Click, ClickType, ElementType } from '@fiverr-private/bianka_js';

export const reportCardClick = () => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Click>({
        type: BIANKA_ACTIVITY_TYPES.CLICK,
        page: {
            name: 'mp_lihp',
            ctxId: pageCtxId,
        },
        event: {
            type: 'user_clicked_on_continue_creating_your_book',
            clickType: ClickType.UNSPECIFIED,
            element: {
                type: ElementType.BUTTON,
                name: 'job_to_be_done_card',
                text: {
                    value: 'continue_creating_your_book',
                },
            },
        },
    });

    mixpanel.track('Book Publishing - Re-Entry point - User enter project experience', {
        Placement: 'JTBD Card',
        Environment: 'MP',
    });
};
